import {Container, Modal, Box, Paper, Button, Alert, Stack, Typography} from "@mui/material";
import {
    NavLink,
    redirect,
    useActionData,
    useLoaderData,
    useNavigate,
    useNavigation,
    useRevalidator,
    useSubmit
} from "react-router-dom";
import api from "../../../../hooks/useApi";
import {useForm} from 'react-hook-form';
import jsonToFormData from "../../../../hooks/jsonToFormData";
import {Autoform} from "../../../../components/forms/autoform";
import PageTitle from "../../../../components/PageTitle";


const formName = 'HotelObjChildren'

export async function action({request, params}) {
    const id = await params.children_object_id;
    const parent_id = await params.object_id;
    const formData = await request.formData();

    try {
        const response = await api.patch(`/api/${formName}/${id}/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    } catch (e) {
        return e;
    }

    return redirect(`/object/${parent_id}/photos`);
}

async function fetchImageAsFile(relativeUrl) {
    try {
        if (!relativeUrl.startsWith('/')) {
            relativeUrl = '/' + relativeUrl;
        }

        let response;
        try {
            response = await api.get(relativeUrl, {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/octet-stream',
                },
            });
        } catch (error) {
            if (error.response && error.response.status === 404) {
                // Return null to signify that the image was not found
                return null;
            } else {
                throw error;
            }
        }

        const blob = response.data;
        const fileName = relativeUrl.split('/').pop(); // Extract file name from URL
        return new File([blob], fileName, {type: blob.type});

    } catch (error) {
        console.error('Error fetching image:', error);
        return null;
    }
}

async function transformPathsToFiles(json) {
    const updatedJson = {...json};

    for (const key in updatedJson) {
        if (updatedJson.hasOwnProperty(key)) {
            const field = updatedJson[key];
            const {type, initial} = field;

            if ((type === 'ClearableFileInput' || type === 'MultiUploadMetaInput') && initial) {
                if (Array.isArray(initial)) {
                    // If initial is an array, fetch each file
                    const files = await Promise.all(initial.map(fetchImageAsFile));
                    updatedJson[key].initial = files;
                } else {
                    // If initial is a single value, fetch the file
                    const file = await fetchImageAsFile(initial);
                    updatedJson[key].initial = file;
                }
            }
        }
    }

    return updatedJson;
}

export async function loader({request, params}) {
    // const id = await params.children_object_id;
    // const form = (await api.get(`/api/image/${formName}/${id}/`)).data.form
    //console.log(form);
    const childId = await params.children_object_id;
    const parentId = await params.object_id;
    const form = (await api.get(`/api/image/${formName}/${childId}/`)).data.form
    const formRevived = await transformPathsToFiles(form);
    const defaultValues = {};
    for (const key in formRevived) {
        if (formRevived.hasOwnProperty(key)) {
            const {initial} = formRevived[key];

            if (initial !== null) {
                defaultValues[key] = initial;
            }
        }
    }

    return {
        form: formRevived,
        // id: id,
        id: childId,
        parentId: parentId,
        defaultValues: defaultValues,
    }
}


export default function EditChildObjectPhotos() {
    const actionData = useActionData();
    const loaderData = useLoaderData();
    const formHook = useForm({
        defaultValues: loaderData.defaultValues
    })
    const revalidator = useRevalidator();
    const submit = useSubmit();

    const handleSubmitForm = (data) => {
        const formData = jsonToFormData(data);
        submit(formData, {
            encType: 'multipart/form-data',
            method: 'post'
        })
    }
    const navigation = useNavigation();

    const isSubmitting = navigation.state === 'submitting';
    return (
        <Modal open={true} className="flex abs-center">
            <Container maxWidth='max' sx={{height: '95vh',}}>
                <Paper sx={{maxHeight: '100%', overflow: 'auto', p: 2, position: 'relative'}}>
                    <PageTitle title={`Редагування фото підоб'єкта: ${loaderData?.id || "ID"}`} />
                    {isSubmitting && (
                        <Box
                            sx={{

                                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                                zIndex: 9999,
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0
                            }}
                        />
                    )}
                    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <h2>Редагувати зображення підоб'єкту</h2>
                        <Button disabled={isSubmitting} component={NavLink} color='secondary'
                                to={`/object/${loaderData.parentId}/photos`} variant='outlined'>
                            закрити
                        </Button>
                    </Box>

                    <Autoform
                        fields={loaderData.form}
                        formHook={formHook}
                        revalidator={revalidator}
                        formName={formName}
                        onSubmit={handleSubmitForm}
                        additionalButton={
                            <Button disabled={isSubmitting} component={NavLink} color='secondary'
                                    to={`/object/${loaderData.parentId}/photos`} variant='contained'>
                                Скасувати
                            </Button>
                        }
                    />
                    {actionData && (
                        <Alert severity='error'>
                            <Stack direction='column' spacing={1}>
                                <Typography>
                                    {actionData.status}
                                </Typography>
                                <Typography>
                                    {actionData?.message && <span>{actionData?.message}</span>}
                                </Typography>
                                <Typography>
                                    {actionData.response?.data &&
                                        <span>{JSON.stringify(actionData.response?.data)}</span>}

                                </Typography>
                            </Stack>
                        </Alert>
                    )}
                </Paper>
            </Container>
        </Modal>
    )
}
